import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { OrganismModel } from './organism.model';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../../utils/common.constants';

@Injectable()
export class OrganismService {
  constructor(private http: HttpClient) {
  }

  private handleError(error: any) {
    return Observable.throw(error || 'Server error');
  }

  /**
   * Service to retrieve Organism list.
   * @returns Returns a list of Organism.
   */
  getOrganisms(): Observable<any> {
    return this.http.get('http://localhost:9190/nazouki/api/partner/organism').
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
    /**
   * Service to search Organism list.
   * @returns Returns a list of Organism.
   */
  searchOrganisms(organismSearch:any) {
      return this.http.post(CommonConstants.env +'api/partner/organism/search', organismSearch)
  }

/**
   * Service to retrieve Organism object for organism id.
   * @param organism id
   * @returns Returns Organism Object.
   */
  getOrganismsById(organsmId: number): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/partner/organism/' + organsmId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  loadPartners(pType:number) {
    return this.http.get(CommonConstants.env + 'api/partner/partner/' + pType).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  errorHandler(error: any): void {
    throwError(error);
  };
}